import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ComonTable from '../../../../../common/table/ComonTable';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { getStatusBadgeStyle } from '../../../../../../utils/statusUtils';

const RentalParkingTable = ({ data, title }) => {
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);
    const roleId = Number(user?.roleId || 3);
    const [searchQuery, setSearchQuery] = useState("");

    const columns = [
        { label: 'RENTAL ID', key: 'id' },
        { label: 'SLOT', key: 'slot' },
        { label: 'RENTED TO', key: 'rentedTo' },
        { label: 'RENTAL PERIOD', key: 'rentalPeriod' },
        { label: 'STATUS', key: 'status' },
        { label: 'ACTIONS', key: 'action_view' }
    ];

    const filteredData = data.filter(item => 
        (item.id && item.id.toString().toLowerCase().includes(searchQuery.toLowerCase())) || 
        (item.rentedTo && item.rentedTo.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (item.slot && item.slot.toLowerCase().includes(searchQuery.toLowerCase()))
    );

    const renderCell = (key, row) => {
        if (key === 'id' || key === 'slot') {
            return <span className="font-bold text-gray-800 dark:text-gray-200 text-[11px]">{row[key]}</span>;
        }
        if (key === 'floor') {
            return <span className="text-blue-500 dark:text-blue-400 font-semibold text-[11px]">{row[key]}</span>;
        }
        if (key === 'rentalPeriod') {
            return <span className="text-gray-600 dark:text-gray-400 text-[11px] font-medium">{row.rentalPeriodStart} to {row.rentalPeriodEnd}</span>;
        }
        if (key === 'status') {
            return <span className={`px-2 py-0.5 rounded text-[9px] font-bold uppercase tracking-wider ${getStatusBadgeStyle(row[key])}`}>
                {row[key] === 'Active' ? 'Active' : row[key]}
            </span>;
        }
        if (key === 'action_view') {
            const isPending = (row.status === 'Pending' || row.status === 'PendingApproval') && roleId === 3;
            return (
                <button 
                    onClick={() => navigate(`/zentcomm/parking-management/rental-parking/${row.id}`)}
                    className={`px-3 py-1.5 text-[10px] font-bold rounded-md transition-colors ${
                        isPending 
                            ? "bg-[#F8FAFC] dark:bg-blue-900/20 text-[#2563EB] dark:text-blue-400 hover:brightness-95 border border-[#E2E8F0] dark:border-blue-800/30" 
                            : "bg-gray-100 dark:bg-actionitembg text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
                    }`}
                >
                    {isPending ? "Review Lease" : "View"}
                </button>
            );
        }
        return <span className="text-[11px] text-gray-700 dark:text-gray-300 font-medium">{row[key]}</span>;
    };

    return (
        <div className="mt-2 bg-white dark:bg-cardbg border border-bordercolor rounded-xl shadow-sm p-5">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
                <h3 className="text-xs font-bold text-gray-800 dark:text-textprimary">{title}</h3>
                <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full sm:w-auto">
                    <div className="relative w-full sm:w-auto">
                        <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-base">search</span>
                        <input 
                            type="text" 
                            placeholder="Search ID or Renter..." 
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="pl-9 pr-4 py-1.5 border border-gray-200 dark:border-bordercolor rounded-lg text-xs w-full sm:w-64 bg-gray-50 dark:bg-actionitembg dark:text-white focus:bg-white dark:focus:bg-cardbg transition-colors outline-none focus:border-blue-300" 
                        />
                    </div>
                    <button className="px-3 py-1.5 border border-gray-200 dark:border-bordercolor bg-gray-50 dark:bg-actionitembg hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 text-[11px] font-bold rounded-lg flex items-center justify-center gap-2 transition-colors">
                        <FontAwesomeIcon icon={faDownload} /> Export
                    </button>
                </div>
            </div>
            <ComonTable 
                data={filteredData} 
                headers={columns} 
                renderCell={renderCell}
                pageInfo={{ currentPage: 1, pageSize: 10, totalPages: 1, totalRecords: filteredData.length }}
                onPageChange={() => {}}
                searchQuery={searchQuery}
            />
        </div>
    );
};

export default RentalParkingTable;
